import { Pagination } from '../../../../interfaces/Pagination';
import { PaginationDto } from '../../../../interfaces/dtos/PaginationDto';

export default function transformPagination(dto: PaginationDto): Pagination {
  if (!dto) return null;
  const result: Pagination = {
    first: cleanValue(dto.first),
    next: cleanValue(dto.next),
    previous: cleanValue(dto.previous),
    last: cleanValue(dto.last),
    current: cleanValue(dto.current),
    recordCount: dto.recordCount,
    pageCount: dto.pageCount,
    pageNumber: dto.pageNumber,
  };
  return result;
}

function cleanValue(value: string): string {
  let result = value?.replace('?messageSource=', '');
  result = result?.replace('/v2/messages', '');
  result = result?.replace('Inbox', '');
  result = result?.replace('Outbox', '');
  result = result?.replace('/', '');
  result = result?.replace('?', '');
  return result;
}
